// extracted by mini-css-extract-plugin
export default {"checkAgroupColor":"ImagensSKU_checkAgroupColor__Li1ZU","itemCheckbox":"ImagensSKU_itemCheckbox__2nizY"};